import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { query, where, collection, onSnapshot } from "firebase/firestore";
 
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdApps, MdClose, MdEdit, MdEditNote } from "react-icons/md"; 
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";  
import Create_ledger_books_accounts from "./create_ledger_books_accounts.jsx";

export default function Ledger_books_account_master() {
    const navigate = useNavigate();
    const servicetablename = "accountingfinancedb";
    const [IsLoading2, setIsLoading2] = useState(true);
    const [isedit, setIsedit] = useState(false);
    const [ledger_accountsdata, setLedger_accountsdata] = useState([]);
    const [voucheruid, setVoucheruid] = useState("");
    const { Toastshow } = Toast();
    // ---------- Live vouchers load ----------
    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        setIsLoading2(true);

        if (!select_company_uid) {
            console.error("No company selected");
            setIsLoading2(false);
            return;
        } 
        // Correct path:
        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "ledger_accounts"),
            where("usecase","==","master") 
        ); 
        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));
                setLedger_accountsdata(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    }, []);

    // ---------- Detect URL UID (reload support) ----------
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");

        if (uid) {
            setVoucheruid(uid);
            setIsedit(true);
        } else {
            setIsedit(false);
        }
    }, [window.location.search]);
    // ↑ Component updates anytime URL changes

    // ---------- Open voucher edit ----------
const openEditVoucher = (uid) => {
    navigate(`/?page=ledger_book_accounts_edit&accountguid=${uid}`, {
        state: { accountguid: uid }
    });
};
    // ---------- Close edit ----------
    const closeEdit = () => {
        navigate("?page=vouchers");     // remove uid from URL
        setIsedit(false);

    };
    //


    return (
        <div> 
            <div className="post-container p-2">
 
                <div className="post_updates">
                 <Create_ledger_books_accounts />
                </div>
                <div className="post_div">
                    <div className="ui-grid-home-items">


                        {IsLoading2 ? (
                            <></>
                        ) : ledger_accountsdata.length === 0 ? (
                            <div className="text-h2 bold p-5">No oucher Found</div>
                        ) : (
                            ledger_accountsdata.map((row) => (
                                <div
                                    className="ui-items p-11 items-back items-back shadow hover rounded cursor"
                                    
                                    key={row.accountguid}
                                >
                                    <table className="b-bottom">
                                        <tr>
                                            <td  > <div
                                                className="button-ui0 bold"
                                                style={{ color: row.status === true ? "green" : "red" }}
                                            >
                                                {row.status === true ? "Activate" : "Deactivate"}
                                            </div></td>
                                            <td width={130} className='text-h3 text-r '>
                                                {row.date_time?.toDate ? (
                                                    <>
                                                        {row.date_time_update.toDate().toLocaleDateString()}{" "}
                                                        {row.date_time_update.toDate().toLocaleTimeString()}
                                                    </>
                                                ) : (
                                                    <div className='contact-details'>No date</div>
                                                )}
                                            </td>
                                            <td width={24}><MdEditNote className="icon red" onClick={() => openEditVoucher(row.accountguid)} /></td>
                                        </tr>
                                    </table>
                                   
                                             <Ledger_accounts_profile accountguid={row.accountguid} />
 

                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>


        </div>
    );
}